import React, { useState } from 'react'
import MessageBox from './MessageBox'
import AdminCustomButton from './AdminCustomButton'
import { IoClose } from 'react-icons/io5'
import Select from 'react-select'

const AdminAwsBucketSelectModal = ({ modelClose, closeModal, action, modalHead, option }) => {

    const [selectedOption, setSelectedOption] = useState(null)

    const selectOptions = option?.map(data => ({
        value: data.id,
        label: data.title
    }));

    return (
        <div className={`modal fade packageModel ${modelClose ? 'd-block show' : ''}`} id="awsBucketModal" tabIndex="-1" role="dialog" aria-labelledby="awsBucketModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content theme-bg-color">
                    <div className="modal-header theme-border-bottom-secondary">
                        <MessageBox text={modalHead || "Select S3 Bucket"} classname="modal-title theme-text-color admin-modal-title fw-bold" />
                        <button type="button" className='bg-transparent border-0 theme-text-color' onClick={() => closeModal()} >
                            <IoClose style={{ width: "25px", height: "25px" }} />
                        </button>
                    </div>
                    <div className="modal-body">
                        <Select
                            options={selectOptions}
                            onChange={(opt) => setSelectedOption(opt)}
                            placeholder="Search and select a bucket..."
                            className="mb-3"
                            isSearchable={true}
                        />
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="bg-transparent theme-text-color sliderBtnText px-2 border-0" onClick={() => closeModal()} >
                            <MessageBox text="Cancel" />
                        </button>
                        <AdminCustomButton 
                            className='px-3 py-1 m-0' 
                            saveMethod={() => action(selectedOption?.value)} 
                            saveText='Select Bucket' 
                            disabled={!selectedOption}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminAwsBucketSelectModal
